module.exports = __webpack_public_path__ + "static/media/businessman.ac461227.svg";